import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { useCore } from "./CoreContextProvider.js";
import {
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  confirmPasswordReset,
  setPersistence,
  inMemoryPersistence,
} from "firebase/auth";
import log from "./log";
import { useNavigate } from "react-router";
import { getSessionLogin, logoutApi, sessionLogin } from "../Api/ApiCalls.js";
export const AuthContext = React.createContext({});

const AuthContextProvider = ({ children }) => {
  const { auth } = useCore();
  const [userData, setUserData] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const navigation = useNavigate();

  const signIn = async (email, password) => {
    try {
      await setPersistence(auth, inMemoryPersistence);
      const result = await signInWithEmailAndPassword(auth, email, password);
      if (result) {
        const token = await result.user.getIdTokenResult();
        const sessionToken = await result.user.getIdToken();
        if (!token.claims || token.claims.role !== "fitfreshadmin") {
          setUserData(null);
          return false;
        } else {
          const tmpUserData = {
            uid: result.user.uid,
            email: result.user.email,
            role: token.claims.role,
          };
          await sessionLogin(sessionToken);
          setUserData(tmpUserData);
          signOut(auth);
          return true;
        }
      } else {
        return false;
      }
    } catch (err) {
      log("Error while sign in user " + err);
    }
  };

  const logOut = async () => {
    if (auth) {
      await logoutApi();
      navigation("/");
    } else {
      log(40001, "SORRY NO AUTH OBJECT" + userData);
    }
  };

  const forgotpassword = (email) => {
    return sendPasswordResetEmail(auth, email);
  };

  const resetPassword = (oobCode, newPassword) => {
    return confirmPasswordReset(auth, oobCode, newPassword);
  };

  const getSession = async () => {
    try {
      const data = await getSessionLogin();
      if (!data) throw new Error("Authentication Failed");
      setUserData(data.user);
      setAuthLoading(false);
    } catch (err) {
      setAuthLoading(false);
    }
  };

  useEffect(() => {
    getSession();
  }, []);

  const value = {
    userData,
    signIn,
    logOut,
    resetPassword,
    authLoading,
    setAuthLoading,
    forgotpassword,
    setUserData,
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};

AuthContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthContextProvider;
